/* ============================================================
   Theme Core Utilities (D1d optimization)
   Externalized from theme.liquid inline <script> to reduce
   render-blocking JS in <head>. Loaded with defer.
   Originally inline; moved 2026-05-15.
   ============================================================ */

/* Image responsive helper - rbi pool collects images that need
   dynamic sizes recalculation on viewport resize */
window.rbi = window.rbi || [];

window.ribSetSize = function (img) {
  if (!img || !img.dataset || !img.dataset.ratio) return;
  if (img.offsetWidth / img.dataset.ratio < img.offsetHeight) {
    img.setAttribute('sizes', Math.ceil(img.offsetHeight * img.dataset.ratio) + 'px');
  } else {
    img.setAttribute('sizes', Math.ceil(img.offsetWidth) + 'px');
  }
};

/* Generic debounce utility used by theme components */
window.debounce = function (fn, wait) {
  var t;
  return function () {
    var ctx = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function () { fn.apply(ctx, args); }, wait);
  };
};

/* Keyboard event codes - used by accessibility/dropdown components */
window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13
};

/* Recalculate sizes for all tracked responsive images on resize */
window.addEventListener('resize', window.debounce(function () {
  for (var i = 0; i < window.rbi.length; i++) {
    window.ribSetSize(window.rbi[i]);
  }
}, 250), { passive: true });
